function formatDate(date) {
  const year = date.getUTCFullYear()
  const month = addLeadingZero(date.getUTCMonth() + 1)
  const day = addLeadingZero(date.getUTCDate())

  return year + '-' + month + '-' + day
}

function formatDateTime(date) {
  const fDate = formatDate(date)
  const hours = addLeadingZero(date.getUTCHours())
  const min = addLeadingZero(date.getUTCMinutes())
  const sec = addLeadingZero(date.getUTCSeconds())
  return fDate + ', ' + hours + ':' + min + ':' + sec
}

function addLeadingZero(n) {
  return (n < 10) ? '0' + n : n
}

export default {
  formatDate,
  formatDateTime,
}



// WEBPACK FOOTER //
// ./src/helpers/dateUtils.js